import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../redux-store";

const selectEntities = (state: RootState) =>
  state.data.equipmentTypes.entities;
const selectIds = (state: RootState) => state.data.equipmentTypes.ids;

export const selectEquipmentTypes = createSelector(
  selectIds,
  selectEntities,
  (ids, entities) => ids.map((id) => entities[id])
);

export const selectEquipmentType =
  (id?: string | null) => (state: RootState) =>
    !id ? undefined : state.data.equipmentTypes.entities[id];

export const selectEquipmentTypeArchiveErrors = (state: RootState) =>
  state.data.equipmentTypes.archiveErrors;

export const selectEquipmentTypesLoading = (state: RootState) =>
  state.data.equipmentTypes.loading;
